"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SupplierIntegrationUseCasesEnum = exports.ConditionMetadataKeysEnum = exports.ConditionKeysEnum = exports.ConditionVariantEnum = void 0;
var ConditionVariantEnum;
(function (ConditionVariantEnum) {
    ConditionVariantEnum["INLINE"] = "inline";
    // TODO: add other type of condition when needed
    // TEMPLATE = 'template', // Condition is within the template
    // AGGREGATE = 'aggregate', // There are multiple condition which could be of different types
})(ConditionVariantEnum = exports.ConditionVariantEnum || (exports.ConditionVariantEnum = {}));
var ConditionKeysEnum;
(function (ConditionKeysEnum) {
    ConditionKeysEnum["IsAnyItemShipped"] = "isAnyItemShipped";
    ConditionKeysEnum["AreNoItemsShipped"] = "areNoItemsShipped";
    ConditionKeysEnum["IsCustomQuotesOrder"] = "isCustomQuotesOrder";
    ConditionKeysEnum["IsDoNotProduceTestOrder"] = "isDoNotProduceTestOrder";
})(ConditionKeysEnum = exports.ConditionKeysEnum || (exports.ConditionKeysEnum = {}));
var ConditionMetadataKeysEnum;
(function (ConditionMetadataKeysEnum) {
    ConditionMetadataKeysEnum["SupplierIntegrationUseCase"] = "supplierIntegrationUseCase";
})(ConditionMetadataKeysEnum = exports.ConditionMetadataKeysEnum || (exports.ConditionMetadataKeysEnum = {}));
var SupplierIntegrationUseCasesEnum;
(function (SupplierIntegrationUseCasesEnum) {
    SupplierIntegrationUseCasesEnum["AutomaticActions"] = "automaticActions";
    SupplierIntegrationUseCasesEnum["ConditionalTransmissions"] = "conditionalTransmissions";
})(SupplierIntegrationUseCasesEnum = exports.SupplierIntegrationUseCasesEnum || (exports.SupplierIntegrationUseCasesEnum = {}));
